<template>
    <div class="mobile-nav" v-if="mobileMenu && isMobile" @click="mobileMenuOpen()">
        <div class="item">
            <img v-if="currentMenuItem.icon" :src="currentMenuItem.icon" :alt="currentMenuItem.title + ' navigation icon'">
            <i v-if="currentMenuItem.faIcon" :class="currentMenuItem.faIcon" class="fa-fw"></i>
            <p v-html="currentMenuItem.title"></p>
            <!--div class="icon-holder" style="padding-top:5px; justify-self:flex-end; margin-left:auto;">
                <img src="/images/icons/notif_ico.svg" alt="">
                <div class="notif-number-holder">
                    <p>2</p>
                </div>
            </div-->
        </div>
    </div>
    <aside id="navigation-aside" class="navigation" :class="[{ collapsed: navCollapsed }, navClass]" v-if="!mobileMenu">
        <div class="toggle-nav-holder" @click="toggleNavigation()">
            <button><img :src="asset('images/icons/collapse_ico.svg')" alt=""></button>
        </div>
        <div class="top-items">
            <div class="item mc" v-if="isMobile"  @click="navItemClicked('mobileclose')">
                <img :src="asset('images/icons/close_ico.svg')" alt="">
            </div>

            <div v-for="menuItem in menu" :key="menuItem.key" :class="[menuItem.class, { active: menuItemActive==menuItem.key }]" @click="navItemClicked(menuItem.key)">
                <img v-if="menuItem.icon" :src="menuItem.icon" alt="">
                <i v-if="menuItem.faIcon" :class="menuItem.faIcon" class="fa-fw"></i>
                <p v-html="menuItem.title"></p>
                <span v-if="menuItem.key === 'drafts' && draftPostsCount > 0" class="drafts-count tag">
                    {{ draftPostsCount }}
                </span>
            </div>

            <template v-if="currentCompany && currentCompany.configuration && currentCompany.configuration.navigation">
                <a v-for="menuItem in currentCompany.configuration.navigation" class="item" :href="menuItem.link" :key="menuItem.link" target="_blank">
                    <img v-if="menuItem.icon" :src="menuItem.icon" alt="">
                    <p v-html="menuItem.name"></p>
                </a>
            </template>

            <div v-if="canAccessAdmin" class="item admin" @click="goToAdmin()"> <!-- TODO: Move to a better spot, probably Top bar -->
                <i class="fa-solid fa-screwdriver-wrench fa-fw"></i>
                <p>{{ $t('global.admin') }}</p>
            </div>

            <router-link v-if="isMobile" :to="{name: 'logout'}" class="item"> <!-- TODO: Also move to a better spot -->
                <i class="fa-regular fa-right-from-bracket fa-fw"></i>
                <p>{{ $t('auth.logout') }}</p>
            </router-link>
        </div>
        <div class="bottom-items">
        </div>

    </aside>
    <div class="navigation-placeholder" :class="placeholderClass">

    </div>
</template>
<script>
import { mapActions, mapState } from 'pinia'
import { useContentLibrary } from '../../stores/content-library';
import { useUser } from '../../stores/user';
import { trans } from 'laravel-vue-i18n';

export default {
    props: {
        isMobile: {
            required: true,
            type: Boolean
        },
        mobileMenu: {
            required: false,
            type: Boolean,
            default: false
        },
        mobileMenuOpened: {
            required: false,
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            menuItemActive: 'dashboard',
            navCollapsed: false,
            navClass: "",
            placeholderClass: "placeholder-wide",
            menu: [
                {
                    key: 'dashboard',
                    title: trans('global.navigation.dashboard'),
                    class: 'item dashboard',
                    // icon: '/images/icons/dashboard_ico.svg',
                    faIcon: 'fa-regular fa-house-blank',
                    route: { name: 'dashboard'}
                },
                {
                    key: 'post maker',
                    title: trans('global.navigation.post_maker'),
                    class: 'item post-maker',
                    // icon: '/images/icons/post_creator_ico.svg',
                    faIcon: 'fa-regular fa-pen',
                    route: { name: 'post maker'}
                },
                {
                    key: 'drafts',
                    title: trans('global.navigation.drafts'),
                    class: 'item drafts',
                    faIcon: 'fa-regular fa-floppy-disk-pen',
                    route: { name: 'drafts'}
                },
                {
                    key: 'calendar',
                    title: trans('global.navigation.calendar'),
                    class: 'item calendar',
                    // icon: '/images/icons/cal_ico.svg',
                    faIcon: 'fa-regular fa-calendar',
                    route: { name: 'calendar'}
                },
                {
                    key: 'content library',
                    title: trans('global.navigation.content_library'),
                    class: 'item content-library',
                    // icon: '/images/icons/content_ico.svg',
                    faIcon: 'fa-regular fa-grid-2',
                    route: { name: 'content library'}
                },
                // {
                //     key: 'business center',
                //     title: 'Business Center',
                //     class: 'item',
                //     icon: '/images/icons/todo_ico.png',
                //     route: { name: 'business center'}
                // },
                // {
                //     key: 'analytics',
                //     title: trans('global.navigation.analytics'),
                //     class: 'item analytics',
                //     faIcon: 'fa-regular fa-chart-mixed',
                //     route: { name: 'analytics'}
                // },
            ]
        };
    },

    emits: ['mobileMenuOpen', 'mobileMenuClose'],

    watch: {
        isMobile(isMobile) {
            if(isMobile) {
                this.adaptToMobile();
            } else {
                this.adaptToFull();
            }
        },

        mobileMenuOpened(opened) {
            if(opened) {
                this.navClass = "menu-opened";
            } else {
                this.onResize();
            }
        },

        $route (to, from) {
            if (to.name != 'logout') {
                this.selectMenuItem();
            }
        },
    },

    created() {
        this.onResize();
        this.selectMenuItem();

        // Show/hide connections
        if(this.assistant === undefined) {
            this.menu.push({
                key: 'connections',
                title: trans('global.navigation.connections'),
                class: 'item connections',
                faIcon: 'fa-regular fa-plug',
                route: { name: 'connections'}
            });
        }

        // Add remaining options
        this.menu.push({
            key: 'training',
            title: trans('global.navigation.training'),
            class: 'item training',
            faIcon: 'fa-light fa-graduation-cap',
            route: { name: 'training home'}
        });
    },

    computed: {
        currentMenuItem() {
            // Only works for items that have route; If we ever have non-route menu items (not recommended), we need to find another way of identifying them.
            return this.menu.find(item => {
                if (item.route !== undefined && item.route != null && (item.route.name == this.$route.name || (item.route.name == 'content library' && this.$route.name == 'my content') || item.route.name.startsWith('training'))) {
                    return true;
                }
                return false;
            });
        },

        ...mapState(useUser, {
            canAccessAdmin: 'canAccessAdmin',
            currentCompany: 'currentCompany',
            canChangePassword: 'canChangePassword',
            temporaryPassword: 'temporaryPassword',
            draftPostsCount: 'draftPostsCount',
            assistant: 'assistant'
        }),
    },

    methods: {
        ...mapActions(useContentLibrary, [
            'resetContentLibrary'
        ]),

        selectMenuItem() {
            let selectedMenuItem = this.menu.find(item => {
                if (item.route !== undefined && item.route != null && this.$route.name !== 'settings' &&
                   (
                        item.route.name == this.$route.name
                        || (item.route.name == 'content library' && this.$route.name == 'my content')
                        || item.route.name.startsWith('training')
                    )
                ) {
                    return true;
                }

                return false;
            });

            if (this.canChangePassword && this.temporaryPassword) {
                this.menuItemActive = '';
            } else {
                this.menuItemActive = selectedMenuItem ? selectedMenuItem.key : '';
            }
        },

        onResize() {
            if(this.isMobile) {
                this.adaptToMobile();
            } else {
                this.adaptToFull();
            }
        },

        adaptToMobile() {
            this.placeholderClass = "placeholder-collapsed";
            this.navClass= "menu-closed";
        },

        adaptToFull() {
            if(this.navCollapsed) {
                this.placeholderClass = "placeholder-narrow";

            } else {
                this.placeholderClass = "placeholder-wide";
            }
            this.navClass="";
        },

        navItemClicked(itemKey) {
            if (this.canChangePassword && this.temporaryPassword) {
                return;
            }

            if (itemKey == 'mobileclose') {
                this.navClass = "menu-closed";
            } else {
                this.menuItemActive = itemKey;

                let item = this.menu.find( menuItem => menuItem.key == itemKey);
                if (item.route !== undefined && item.route != null) {
                    if(['post maker', 'content library'].includes(item.key)) {
                        // Reset Content Library when going to the Post Maker/Content Library directly
                        this.resetContentLibrary();
                    }
                    this.$router.push(item.route);
                }
            }

            this.$emit('mobileMenuClose');
        },

        goToAdmin() { // this is a temporary solution until we find a better place for the admin link
            window.location = '/admin';
        },

        toggleNavigation() {
            if(this.navCollapsed) {
                //Expand navigation
                this.navClass = "nav-expand";
                this.placeholderClass = "placeholder-wide";
                setTimeout(()=>{
                    this.navCollapsed=!this.navCollapsed;
                },200);
            } else {
                //Collapse navigation
                this.navCollapsed=!this.navCollapsed
                setTimeout(()=>{
                    this.navClass = "nav-collapse";
                    this.placeholderClass = "placeholder-narrow";
                },200);
            }
        },

        mobileMenuOpen() {
            this.$emit('mobileMenuOpen');
        }
    }
}
</script>
